var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "menuDetail" },
      [
        _vm._l(_vm.routes, function(item) {
          return [
            !item.hidden && item.children
              ? _c(
                  "div",
                  {
                    key: item.name,
                    staticClass: "menuDetail_item subLink",
                    class: { "submenu-title-noDropdown": true },
                    attrs: { index: _vm.route.path + "/" + item.path }
                  },
                  [
                    item.meta && item.meta.icon
                      ? _c("svg-icon", {
                          attrs: { "icon-class": item.meta.icon }
                        })
                      : _vm._e(),
                    item.meta && item.meta.title
                      ? _c("span", { staticStyle: { "line-height": "40px" } }, [
                          _vm._v(_vm._s(item.meta.title))
                        ])
                      : _vm._e(),
                    _vm._l(item.children, function(subItem) {
                      return [
                        !subItem.hidden && subItem.children === null
                          ? _c(
                              "router-link",
                              {
                                key: subItem.name,
                                staticClass: "menuDetail_item",
                                attrs: {
                                  to:
                                    item.path +
                                    "/" +
                                    subItem.path +
                                    (subItem.props !== undefined
                                      ? "?" + _vm.getQuery(subItem.props)
                                      : "")
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.chooseRouters(item)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "threeSubLink",
                                    class: { "submenu-title-noDropdown": true },
                                    attrs: {
                                      index: item.path + "/" + subItem.path
                                    }
                                  },
                                  [
                                    subItem.meta && subItem.meta.icon
                                      ? _c("svg-icon", {
                                          attrs: {
                                            "icon-class": subItem.meta.icon
                                          }
                                        })
                                      : _vm._e(),
                                    subItem.meta && subItem.meta.title
                                      ? _c("span", [
                                          _vm._v(_vm._s(subItem.meta.title))
                                        ])
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        !subItem.hidden && subItem.children
                          ? _c(
                              "div",
                              {
                                key: subItem.name,
                                staticClass: "subMenu",
                                class: { "submenu-title-noDropdown": true },
                                attrs: { index: item.path + "/" + subItem.path }
                              },
                              [
                                subItem.meta && subItem.meta.icon
                                  ? _c("svg-icon", {
                                      attrs: { "icon-class": subItem.meta.icon }
                                    })
                                  : _vm._e(),
                                subItem.meta && subItem.meta.title
                                  ? _c("span", [
                                      _vm._v(_vm._s(subItem.meta.title))
                                    ])
                                  : _vm._e(),
                                _vm._l(subItem.children, function(thirdItem) {
                                  return !thirdItem.hidden &&
                                    thirdItem.children === null
                                    ? [
                                        _c(
                                          "router-link",
                                          {
                                            key: thirdItem.name,
                                            staticClass: "menuDetail_item",
                                            attrs: {
                                              to:
                                                subItem.path +
                                                "/" +
                                                thirdItem.path +
                                                (thirdItem.props !== undefined
                                                  ? "?" +
                                                    _vm.getQuery(
                                                      thirdItem.props
                                                    )
                                                  : "")
                                            },
                                            nativeOn: {
                                              click: function($event) {
                                                return _vm.chooseRouters(
                                                  subItem
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "fourSubLink",
                                                class: {
                                                  "submenu-title-noDropdown": true
                                                },
                                                attrs: {
                                                  index:
                                                    subItem.path +
                                                    "/" +
                                                    thirdItem.path
                                                }
                                              },
                                              [
                                                thirdItem.meta &&
                                                thirdItem.meta.icon
                                                  ? _c("svg-icon", {
                                                      attrs: {
                                                        "icon-class":
                                                          thirdItem.meta.icon
                                                      }
                                                    })
                                                  : _vm._e(),
                                                thirdItem.meta &&
                                                thirdItem.meta.title
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          thirdItem.meta.title
                                                        )
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e()
                                })
                              ],
                              2
                            )
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              : !item.hidden && item.children === null
              ? _c(
                  "router-link",
                  {
                    key: item.name,
                    staticClass: "menuDetail_item threeSubLink",
                    attrs: {
                      to:
                        _vm.route.path +
                        "/" +
                        item.path +
                        (item.props !== undefined
                          ? "?" + _vm.getQuery(item.props)
                          : "")
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.chooseRouters(_vm.route)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        class: { "submenu-title-noDropdown": true },
                        attrs: { index: _vm.route.path + "/" + item.path }
                      },
                      [
                        item.meta && item.meta.icon
                          ? _c("svg-icon", {
                              attrs: { "icon-class": item.meta.icon }
                            })
                          : _vm._e(),
                        item.meta && item.meta.title
                          ? _c(
                              "span",
                              { staticStyle: { "line-height": "40px" } },
                              [_vm._v(_vm._s(item.meta.title))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }